'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _twemoji = require('twemoji');

var _twemoji2 = _interopRequireDefault(_twemoji);

var _countryTelephoneData = require('country-telephone-data');

var _mapValues = require('lodash/mapValues');

var _mapValues2 = _interopRequireDefault(_mapValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var codePoints = {
  A: '\uD83C\uDDE6',
  B: '\uD83C\uDDE7',
  C: '\uD83C\uDDE8',
  D: '\uD83C\uDDE9',
  E: '\uD83C\uDDEA',
  F: '\uD83C\uDDEB',
  G: '\uD83C\uDDEC',
  H: '\uD83C\uDDED',
  I: '\uD83C\uDDEE',
  J: '\uD83C\uDDEF',
  K: '\uD83C\uDDF0',
  L: '\uD83C\uDDF1',
  M: '\uD83C\uDDF2',
  N: '\uD83C\uDDF3',
  O: '\uD83C\uDDF4',
  P: '\uD83C\uDDF5',
  Q: '\uD83C\uDDF6',
  R: '\uD83C\uDDF7',
  S: '\uD83C\uDDF8',
  T: '\uD83C\uDDF9',
  U: '\uD83C\uDDFA',
  V: '\uD83C\uDDFB',
  W: '\uD83C\uDDFC',
  X: '\uD83C\uDDFD',
  Y: '\uD83C\uDDFE',
  Z: '\uD83C\uDDFF'
};

var isoUnicode = _countryTelephoneData.allCountries.reduce(function (isoMap, country) {
  var iso2 = country.iso2;

  var key = iso2.toUpperCase();
  var utfCode = '' + codePoints[key[0]] + codePoints[key[1]];
  /* eslint-disable no-param-reassign */
  isoMap[key] = utfCode;
  /* eslint-enable no-param-reassign */
  return isoMap;
}, {});

var emojiFlags = (0, _mapValues2.default)(isoUnicode, function (code) {
  return _twemoji2.default.parse(code).replace('class="emoji"', 'class="select-emoji');
});

exports.default = emojiFlags;